<template>
  <v-row>
    <v-card tile width="800" class="mx-auto secundary5 mt-5">
      <v-card-title class="text-subtitle-1">Solicitudes</v-card-title>
      <v-card-subtitle>
        Podrás aceptar las solicitudes de los profesionales para puedan admitirte como su
        paciente. Revise su correo para aceptar la solicitud.
      </v-card-subtitle>
      <v-data-table
        :headers="headersTable"
        :items="recordDerivations"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        dense
        hide-default-footer
        class="elevation-1 secundary5"
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            text
            color="blue darken-1"
            x-small
            @click="agreeDerivation(item)"
            v-if="item.authorization === ''"
          >
            Aceptar
          </v-btn>
        </template>
      </v-data-table>
      <div class="d-flex justify-space-between">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
      <v-row> </v-row>
      <v-row class="mt-3">
        <span class="secundary5--text lighten-3"> .</span>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: 'VTableDerivations',
  props: ['headersTable', 'recordDerivations', 'agreeDerivation'],
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
};
</script>
